import { ServiceCard } from '@/components/sv'
import { useRBAC } from '@/lib/hooks'
import { RECENT_SERVICES_DISPLAY_COUNT } from '@/routes/home/recent-services/query'

export const RecentServicesFallback = () => {
  const { totalServices } = useRBAC()

  const numberOfTotalServices =
    totalServices.totalApps +
    totalServices.totalDatabases +
    totalServices.totalStaticSites +
    totalServices.totalObjectStorages +
    totalServices.totalLoadBalancers

  const numberToDisplay =
    numberOfTotalServices <= RECENT_SERVICES_DISPLAY_COUNT
      ? numberOfTotalServices
      : RECENT_SERVICES_DISPLAY_COUNT

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {new Array(numberToDisplay).fill(null).map((_, index) => (
        <ServiceCard key={index} type="app" loading name="" />
      ))}
    </div>
  )
}
